import { render, staticRenderFns } from "./AgreementStorageViewer.vue?vue&type=template&id=041ca84b&scoped=true&"
import script from "./AgreementStorageViewer.vue?vue&type=script&lang=ts&"
export * from "./AgreementStorageViewer.vue?vue&type=script&lang=ts&"
import style0 from "./AgreementStorageViewer.vue?vue&type=style&index=0&id=041ca84b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "041ca84b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VContainer,VDataTable,VRow})
